import React from 'react';
import PropTypes from 'prop-types';

import Header from './shared/Header';
import PhotoGallery from '../../components/PhotoGallery';

import { withAppContext } from '../../contexts/app';

class Photos extends React.Component {
  constructor(props) {
    super(props);

    const { condition, app } = props;
    const imageBaseUrl = app.healthPages.baseUrl;

    this.state = {
      title: condition.title,
      photos: condition.sample_images.map((i) => ({
        title: i.title,
        url: `${imageBaseUrl}/${i.image_url}`,
        thumb: `${imageBaseUrl}/${i.thumbnail_url}`
      }))
    };
  }

  render() {
    const { title, photos } = this.state;
    const { history } = this.props;
    const { location } = history;
    const backButtonLabel = location.state ? location.state.backButtonLabel : `Back to ${title}`;

    return (
      <div className="condition-photos">
        <Header
          className="condition-photos__header"
          title={`${title ? `${title} ` : ''}Gallery`}
          showBackButton={true}
          backButtonLabel={backButtonLabel}
          onBackButtonClick={this.handleBackButtonClick.bind(this)}
        />

        <div className="container condition-photos__photo-gallery">
          <PhotoGallery photos={photos} showPhotoTitles={false} />
        </div>
      </div>
    );
  }

  handleBackButtonClick() {
    const { condition, history } = this.props;
    const { location } = history;

    if (location.state) {
      history.goBack();
    } else {
      history.push(`/health/conditions/${condition.id}`);
    }
  }
}

Photos.defaultProps = {};

Photos.propTypes = {
  condition: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    sample_images: PropTypes.array.isRequired
  }),
  app: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export { Photos };
export default withAppContext(Photos);
